import React from 'react'
import { Typography } from '@mui/material'
import { OrgUserRole, User } from 'api/model'

const UserRole = ({ user, activeOrganization }: { user: User; activeOrganization: string | null }) => {
  const label = () => {
    switch (user.profiles.find((up) => up.organization.id === activeOrganization)?.role) {
      case OrgUserRole.admin:
        return 'Admin'
      case OrgUserRole.member:
        return 'Member'
    }
  }

  return <Typography variant="pS">{label()}</Typography>
}

export default UserRole
